import * as i0 from '@angular/core';
import { Directive, inject, EventEmitter, Input, Output } from '@angular/core';
import { TuiElement } from '@taiga-ui/cdk/directives/element';
import { tuiPx } from '@taiga-ui/cdk/utils/miscellaneous';
let TuiResizable = /*#__PURE__*/(() => {
  class TuiResizable extends TuiElement {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵTuiResizable_BaseFactory;
        return function TuiResizable_Factory(__ngFactoryType__) {
          return (ɵTuiResizable_BaseFactory || (ɵTuiResizable_BaseFactory = i0.ɵɵgetInheritedFactory(TuiResizable)))(__ngFactoryType__ || TuiResizable);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiResizable,
        selectors: [["", "tuiResizable", ""]],
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return TuiResizable;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiResizer = /*#__PURE__*/(() => {
  class TuiResizer {
    constructor() {
      this.resizable = inject(TuiResizable);
      this.x = NaN;
      this.y = NaN;
      this.width = 0;
      this.height = 0;
      this.tuiResizer = [0, 0];
      this.tuiSizeChange = new EventEmitter();
    }
    get cursor() {
      if (!this.tuiResizer[0]) {
        return 'ns-resize';
      }
      if (!this.tuiResizer[1]) {
        return 'ew-resize';
      }
      if (this.tuiResizer[0] * this.tuiResizer[1] > 0) {
        return 'nwse-resize';
      }
      return 'nesw-resize';
    }
    onPointerDown(x, y) {
      this.x = x;
      this.y = y;
      this.width = this.resizable.nativeElement.clientWidth;
      this.height = this.resizable.nativeElement.clientHeight;
    }
    onPointerMove({
      x,
      y,
      buttons
    }) {
      if (!buttons) {
        this.onPointerUp();
      } else {
        this.onMove(x, y);
      }
    }
    onPointerUp() {
      this.x = NaN;
    }
    onMove(x, y) {
      if (Number.isNaN(this.x)) {
        return;
      }
      const {
        style
      } = this.resizable.nativeElement;
      const size = [this.width + this.tuiResizer[0] * (x - this.x), this.height + this.tuiResizer[1] * (y - this.y)];
      if (this.tuiResizer[0]) {
        style.width = tuiPx(size[0]);
      }
      if (this.tuiResizer[1]) {
        style.height = tuiPx(size[1]);
      }
      this.tuiSizeChange.emit(size);
    }
    static {
      this.ɵfac = function TuiResizer_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiResizer)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiResizer,
        selectors: [["", "tuiResizer", ""]],
        hostVars: 4,
        hostBindings: function TuiResizer_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("pointerdown.zoneless.prevent", function TuiResizer_pointerdown_zoneless_prevent_HostBindingHandler($event) {
              return ctx.onPointerDown($event.x, $event.y);
            })("pointermove.zoneless", function TuiResizer_pointermove_zoneless_HostBindingHandler($event) {
              return ctx.onPointerMove($event);
            }, false, i0.ɵɵresolveDocument)("pointerup.zoneless", function TuiResizer_pointerup_zoneless_HostBindingHandler() {
              return ctx.onPointerUp();
            }, false, i0.ɵɵresolveDocument);
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("cursor", ctx.cursor)("touch-action", "none");
          }
        },
        inputs: {
          tuiResizer: "tuiResizer"
        },
        outputs: {
          tuiSizeChange: "tuiSizeChange"
        }
      });
    }
  }
  return TuiResizer;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiResizable, TuiResizer };
